/**
 * 路线业务类型（与后端 tms_route / tms_task.business_type 一致）
 * 1-自有路线 2-TikTok 3-Temu GA（USPS） 4-Temu SCF（送至清关行）
 */
export enum TmsRouteBusinessType {
  OWN = 1,
  TIKTOK = 2,
  TEMU_TRANSFER = 3,
  TEMU_SCF = 4,
}

/**
 * 任务类型（与 tms_task.task_type 一致）
 * 1-常规 2-临时 3-三方任务
 */
export enum TmsTaskClassificationType {
  REGULAR = 1,
  TEMPORARY = 2,
  THIRD_PARTY_TASK = 3,
}

/**
 * 路线类型枚举
 */
export enum RouteType {
  LINEHAUL = 1, // 干线
  FEEDER = 2, // 支线
  HANDOVER = 3, // 交接
}

/**
 * 途经点状态枚举
 */
export enum WaypointStatus {
  PENDING_ARRIVAL = 1, // 待到站
  ARRIVED = 2, // 已到站
  DEPARTED = 3, // 已发车
  PENDING_DEPARTURE = 4, // 待发车
}

/**
 * 计划时间类型枚举
 */
export enum PlanTimeType {
  DEPARTURE = 1, // 发车
  ARRIVAL = 2, // 到达
}

/**
 * 途经点类型枚举
 */
export enum WaypointType {
  ORIGIN = 1, // 起点
  WAYPOINT = 2, // 途经点
  DESTINATION = 3, // 终点
}

/**
 * 容器类型枚举（对应后端 TmsTaskContainerTypeEnum）
 * 1-卡板箱 2-蛇皮袋 3-托盘 4-Gaylord
 */
export enum TmsTaskContainerType {
  CARTON = 1, // 卡板箱
  BAG = 2, // 蛇皮袋
  PALLET = 3, // 托盘
  GAYLORD = 4 // Gaylord
}

/** 容器类型顺序（用于表单、列表展示） */
export const TMS_CONTAINER_TYPE_ORDER: number[] = [
  TmsTaskContainerType.CARTON,
  TmsTaskContainerType.BAG,
  TmsTaskContainerType.PALLET,
  TmsTaskContainerType.GAYLORD
];

/**
 * TMS任务途经点节点类型（tms_task_waypoint_location_info.node_type）
 */
export enum TmsTaskWaypointNodeType {
  DRIVER_ARRIVAL = 1, // 司机到达
  UNSEAL = 2,         // 解封车
  LOADING = 3,        // 装车
  UNLOADING = 4,      // 卸车
  SEAL = 5,           // 封车
  DEPARTURE = 6       // 发车
}

/**
 * 操作来源枚举（tms_operation_log.operation_source）
 */
export enum TmsOperationSourceEnum {
  APP = 1,   // APP司机端
  PDA = 2,   // PDA
  PC = 3,    // PC服务端
}
